// tslint:disable:ordered-imports
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ProgramArticleService } from "../../services/program-article.service";
import { ProgramArticle } from "../../models/program-article";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import {
  FiltersActions,
  FiltersStateInterface,
  FILTERS_SAVED
} from "../../store/actions/filters.actions";
import { Store } from "@ngrx/store";
import { ChannelService } from "../../services/channel.service";
import { User } from "../../models/user";
import { Subscription } from "rxjs/Subscription";
import { Value } from "../../models/value";
import {
  ProgramArticlesActions,
  ProgramArticlesStateInterface,
} from "../../store/actions/program-articles.actions";
import { saveAs } from "file-saver";
import { Channel } from "../../models/channel";
import { INITIAL_FILTERS_STATE } from "../../store/reducers/filters.reducer";
import * as _ from "lodash";
import { MdDialog } from "@angular/material";
import { WarningModalComponent } from "../../modals/warning-modal/warning-modal.component";
import { SidenavService } from "../../services/sidenav.service";

@Component({
  selector: "app-program-articles",
  templateUrl: "./program-articles.component.html",
  styleUrls: ["./program-articles.component.scss"],
})

export class ProgramArticlesComponent implements OnInit, OnDestroy {
  programArticles: ProgramArticle[];
  activePage: number;
  loading: boolean;
  currentId: number;
  user: User;
  languageChanged: boolean;
  filters: FiltersStateInterface;
  subscriptions: Subscription[];
  subscriptionFilters: Subscription;
  destinations: Value[];
  destinationForExtract: Value;
  destinationSelected: Value;
  currentProgramArticle: ProgramArticle;
  userChannels: Channel[];
  filtersTouched: boolean;
  filtersTouchedByUser: boolean;
  extractLoading: boolean;
  isSeeReplay: number;

  /**
   * Initialize variables
   * @param {ProgramArticleService} programArticleService
   * @param {ChannelService} channelService
   * @param {Title} title
   * @param {Router} router
   * @param {FiltersActions} filtersAction
   * @param {ProgramArticlesActions} programArticlesActions
   * @param {Store<any>} store
   */
  constructor(
    private programArticleService: ProgramArticleService,
    private channelService: ChannelService,
    private title: Title,
    private mdDialog: MdDialog,
    private router: Router,
    private programArticlesActions: ProgramArticlesActions,
    private filtersActions: FiltersActions,
    private store: Store<any>,
    private sidenavService: SidenavService
  ) {
    this.title.setTitle("Taiga - Program Articles");
    this.sidenavService.currentTab = "Program Articles";
    this.activePage = 1;
    this.subscriptions = [];
    this.filtersTouched = false;
    this.filtersTouchedByUser = false;
    this.extractLoading = false;
    this.isSeeReplay = 1;
  }

  /**
   * Check if a sub route is already defined and load data
   */
  ngOnInit() {
    /**
     * Get destinations from localstorage
     */
    this.destinations = JSON.parse(localStorage.getItem("destinations")).filter(
      (destination) => destination.id != "AllDestinations"
    );
    if (this.filters) {
      this.destinationSelected = this.destinations.find(
        (d) => d.value === this.filters.defaultDestination
      );
    }

    if (!this.destinationSelected) {
      this.destinationSelected = this.destinations[0];
    }

    /**
     * Get the current user from the store
     */
    this.subscriptions.push(
      this.store.select("userState").subscribe((user: User) => {
        if (user && user.currentLanguage) {
          this.user = user;
          this.languageChanged = true;
          if (this.filters) {
            this.filters.fromDashboard = false;
          }

          /**
           * Load countries from API
           */
          this.init();
        }
      })
    );

    /**
     * Get the program articles from the store
     */
    this.subscriptions.push(
      this.store
        .select("programArticlesState")
        .subscribe((programArticlesState: ProgramArticlesStateInterface) => {
          this.programArticles = programArticlesState.programArticles;
          this.programArticles.forEach((progamArticle) =>
            progamArticle.getTitle(this.destinationSelected)
          );
          this.currentProgramArticle =
            programArticlesState.currentProgramArticle;
        })
    );
  }

  /**
   * On destroy event, unsubscribe all the subscriptions
   */
  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptionFilters.unsubscribe();
    this.programArticlesActions.setCurrentProgramArticle(null);
    this.programArticlesActions.setProgramArticles([]);
  }

  // Reviver to parse JSON Date from string
  dateTimeReviver = function (key, value) {
    if (typeof value === "string" && /^\d\d\d\d-\d\d-\d\dT\d\d:\d\d:\d\d.\d\d\dZ$/.test(value)) {
      return new Date(value);
    }
  return value;
  }

  /**
   * Initialize all data for the program articles search
   */
  init() {
    if (this.subscriptionFilters) {
      this.subscriptionFilters.unsubscribe();
    }
    this.subscriptionFilters = this.store
      .select("filtersState")
      .subscribe((filters: FiltersStateInterface) => {
        this.filters = filters;
        this.filters.defaultDestination = this.destinationSelected.value;
        
        if (this.filtersTouched === false || this.languageChanged) {
          this.channelService
            .getUserChannels(this.user.currentLanguage)
            .subscribe((channels) => {
              this.userChannels = channels;
              if (!this.filters.fromDashboard) {
                if (this.filtersTouched === true) {
                  const channelsChecked = filters.channels;
                  filters.channels = filters.channels.filter((channel) => {
                    return !!(
                      !channel.isMain &&
                      channelsChecked.find((c) =>
                        channels.find((ch) => ch.id === c.id)
                      )
                    );
                  });
                  filters.channels = this.filters.channels.concat(
                    channels.filter((channel) => channel.isMain === true)
                  );
                } else {
                  filters.channels = channels.filter(
                    (channel) => channel.isMain === true
                  );
                }
              }
              this.filtersTouched = true;
              this.languageChanged = false;
              var filterFromLocalStorage = JSON.parse(localStorage.getItem(FILTERS_SAVED), this.dateTimeReviver);
              if (filterFromLocalStorage != null) {
                filters = filterFromLocalStorage;
              }
              this.filtersActions.setFilters(filters);
              this.checkFiltersState(filters);
            });
        } else {
          // Reset active page to 1
          this.activePage = 1;
          localStorage.setItem(FILTERS_SAVED, JSON.stringify(this.filters));
          this.getProgramArticles(filters);
          this.checkFiltersState(filters);
        }
      });
  }

  /**
   * Define the current program article as active in the list
   * @param {ProgramArticle} programArticle
   */
  setCurrentProgramArticle(programArticle: ProgramArticle) {
    if (programArticle && programArticle.valEmiId) {
      this.router.navigate([
        "/",
        "program-articles",
        programArticle.valEmiId,
        programArticle.channel.id,
        programArticle.language.id,
        programArticle.cocoonId,
        this.isSeeReplay
      ]);
      this.programArticles.map((item) => (item.active = false));
      programArticle.active = true;
    }
  }

  /**
   * Fetch the program articles from the filters
   * @param {FiltersStateInterface} filters
   */
  getProgramArticles(filters: FiltersStateInterface) {
    this.loading = true;
    this.programArticleService
      .getProgramArticles(filters, this.user.currentLanguage)
      .subscribe((programArticles) => {
        if (this.currentProgramArticle === null) {
          this.setCurrentProgramArticle(programArticles[0]);
        }
        this.programArticlesActions.setProgramArticles(programArticles);
        this.loading = false;
      });
  }

  /**
   * Fetch the extract file and generate an url for the user
   * @param {string} format
   */
  extract(format: string) {
    this.extractLoading = true;
    this.programArticleService
      .getExtract(
        format,
        this.destinationForExtract.value,
        this.filters,
        this.user.currentLanguage.id
      )
      .subscribe((res) => {
        if (res.value) {
          const base64url =
            "data:" + res.value.mimeType + ";base64," + res.value.value;
          fetch(base64url)
            .then((response) => response.blob())
            .then((blob) => {
              this.extractLoading = false;
              saveAs(blob, res.value.id);
            });
        } else {
          this.extractLoading = false;
          this.mdDialog.closeAll();
          this.mdDialog.open(WarningModalComponent, {
            data: {
              title: "Extract failed.",
              content: "Making the date range lower can solve this issue.",
            },
          });
        }
      });
  }

  /**
   * Check if the filters has been modified by the user
   * @param {FiltersStateInterface} filters
   */
  checkFiltersState(filters: FiltersStateInterface) {
    const initialFilters = INITIAL_FILTERS_STATE;
    if (this.userChannels) {
      initialFilters.channels = this.userChannels.filter(
        (channel) => channel.isMain === true
      );
      this.filtersTouchedByUser = !_.isEqual(filters, initialFilters);
    }
  }

  changeDestination() {
    localStorage.setItem("defaultDestination", this.destinationSelected.value);
    this.filters.defaultDestination = this.destinationSelected.value;
    this.filtersActions.setFilters(this.filters);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/program-articles/program-articles.component.ts